import styled from 'styled-components'
import {device} from '../../../theme'

export const IntroBlocksWrap = styled.section `
    padding-top: 80px;
    padding-bottom: 40px;
    @media ${device.medium}{
        padding-top: 60px;
        padding-bottom: 20px;
    }
    @media ${device.small}{
        padding-top: 40px;
        padding-bottom: 10px;
    }
`;

export const Box = styled.div `
    border: 1px solid ${props => props.theme.colors.borderColor};
    border-radius: 5px;
    padding: 35px 40px;
    height: 100%;
    margin-bottom: 30px;
    @media ${device.small}{
        padding: 28px 25px;
    }
`;
